export default "__VITE_ASSET__BMpY2K3Z__"